import * as React from 'react';

import { Typography } from 'components';
import { useStyles } from './Notification.styles';
import { useTranslation } from 'react-i18next';

type NotificationProps = {
  image?: React.ReactNode;
  title?: string;
  description?: string;
  button?: React.ReactNode;
};

const Notification: React.FC<NotificationProps> = ({ image, title, description, button }) => {
  const styles = useStyles();
  const { t } = useTranslation();
  return (
    <section className={styles.root}>
      {image && <figure className={styles.img}>{image}</figure>}
      {title && (
        <Typography textColor="black" className={styles.title} align="center">
          {t(title)}
        </Typography>
      )}
      {description && (
        <Typography textColor="grey" textType="title" align="center" className={styles.description}>
          {t(description)}
        </Typography>
      )}
      {button && <div className={styles.button}>{button}</div>}
    </section>
  );
};

export default Notification;
